import { SharedFunnelDatalayerEvent } from '../../_services/types/datalayer.types';
import { ClaimType, getClaimTypeLabel } from '../../enums/claim/claim-type.enum';

export const GENERIC_BUSINESS_CLAIM_BASE_URL = 'sinistre-generique';

export const getGenericBusinessClaimFunnelEventBase = (
  claimType: ClaimType,
): SharedFunnelDatalayerEvent => ({
  product_category: `${getClaimTypeLabel(claimType)}_Entreprise`,
  product_name: 'Claim',
  funnel_complete: false,
  get event() {
    return `${this.product_name}_${this.product_category}`;
  },
});

export const GENERIC_BUSINESS_CLAIM_STEPS = {
  LOSS_DETAILS: {
    url: 'details',
    step: [3, 1],
    datalayerEvent: (claimType: ClaimType) => ({
      ...getGenericBusinessClaimFunnelEventBase(claimType),
      funnel_stage: 4,
      stage_name: 'Details perte',
    }),
  },
  DOCUMENTS: {
    url: 'documents',
    step: [3, 1],
    datalayerEvent: (claimType: ClaimType) => ({
      ...getGenericBusinessClaimFunnelEventBase(claimType),
      funnel_stage: 5,
      stage_name: 'Documents',
    }),
  },
  VALIDATION: {
    url: 'validation',
    step: [4, 1],
    datalayerEvent: (claimType: ClaimType) => ({
      ...getGenericBusinessClaimFunnelEventBase(claimType),
      funnel_stage: 6,
      stage_name: 'Validation',
    }),
  },
} as const;

// Mapping of claim types to their base URLs
export const GENERIC_CLAIM_TYPE_TO_BASE_URL: { [key in ClaimType]?: string } = {
  [ClaimType.BUSINESS_MOTOR_VEHICLE]: 'vehicule-entreprise',
  [ClaimType.BUSINESS_RETIREMENT]: 'retraite-entreprise',
  [ClaimType.BUSINESS_LEGAL_PROTECTION]: 'protection-juridique-entreprise',
  [ClaimType.BUSINESS_BUILDING]: 'batiment-entreprise',
  [ClaimType.BUSINESS_CONSTRUCTION]: 'construction-entreprise',
  [ClaimType.BUSINESS_TRANSPORT]: 'transport-entreprise',
  [ClaimType.BUSINESS_CYBERSECURITY]: 'cybersecurite-entreprise',
  [ClaimType.BUSINESS_TECHNICAL_INSTALLATION]: 'installation-technique-entreprise',
};

export const getGenericClaimBaseUrl = (claimType: ClaimType): string =>
  GENERIC_CLAIM_TYPE_TO_BASE_URL[claimType] || GENERIC_BUSINESS_CLAIM_BASE_URL;
